import { render, staticRenderFns } from "./ClientSubAccounts.vue?vue&type=template&id=44dc5387"
import script from "./ClientSubAccounts.vue?vue&type=script&lang=js"
export * from "./ClientSubAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports